// 广告配置
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- search start -->
    <div class="search-area">
      <el-row :gutter="24" style="height:34px">
        <el-col :span="6">
          <div class="search-area-div">广告名称</div>
          <el-input size="mini" class="ipt-sty" v-model="page.advertName" placeholder="请输入" filterable> </el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">上架状态</div>
          <el-select size="mini" class="ipt-sty" v-model="page.isUse" placeholder="请选择" filterable>
            <el-option v-for="item in reviewStatus" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- search end -->

    <!-- table start -->
    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px'">
      <div class="button-area">
        <el-button size="mini" type="info" @click="addAdv" v-loading.fullscreen.lock="fullscreenLoading"
          >添加广告</el-button
        >
      </div>
      <el-table :height="tableHeight" :data="tableData" stripe border style="width: 100%" v-loading="tableLoading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="templateName"
          label="广告名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="220"
        >
          <template slot-scope="scope">{{ scope.row.advertName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="广告图片"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="96"
        >
          <template slot-scope="scope">{{ scope.row.advertPhotoUrl | havePic }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="支持广告分享"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="96"
        >
          <template slot-scope="scope">{{ scope.row.isSharePoster | supported }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="分享海报图片"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="96"
        >
          <template slot-scope="scope">{{ scope.row.posterPhotoUrl | havePic }}</template>
        </el-table-column>
        <el-table-column
          width="96"
          show-overflow-tooltip
          prop="createTime"
          label="目标跳转链接"
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{
            scope.row.targetUrlValue
              ? scope.row.targetUrlType === '1'
                ? getName(scope.row.targetUrlValue,'广告目标页面')
                : scope.row.targetUrlValue
              : '-'
          }}</template>
        </el-table-column>
        <el-table-column width="96" prop="createTime" label="广告顺序" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.advertSeq }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          width="96"
          label="阅读次数"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{ scope.row.readCount || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="阅读人数"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="96"
        >
          <template slot-scope="scope">{{ scope.row.readStaffNum || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="分享次数"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="96"
        >
          <template slot-scope="scope">{{ scope.row.shareCount || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="填写人数"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="96"
        >
          <template slot-scope="scope">{{ scope.row.inputStaffNum || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="上架状态"
          show-overflow-tooltip
          header-align="center"
          align="center"
          width="96"
        >
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.isUse" :type="type[scope.row.isUse]">{{
              isUseObj[scope.row.isUse] || '-'
            }}</el-tag>
            <span v-else>{{ '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="操作人"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="96"
        >
          <template slot-scope="scope">{{ scope.row.updateUserName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="操作时间"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="190"
        >
          <template slot-scope="scope">{{ scope.row.updateTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column prop="bank" min-width="140" label="操作" header-align="center" align="center" fixed="right">
          <template slot-scope="scope">
            <div>
              <a class="txt-color" @click="toEdit(scope.row)">编辑 | </a>
              <a class="txt-color" v-if="scope.row.isUse === 'Y'" @click="toUse(scope.row, 'N')">下架 | </a>
              <a class="txt-color" v-if="scope.row.isUse === 'N'" @click="toUse(scope.row, 'Y')">上架 | </a>
              <a
                class="txt-color"
                style="color: #999 !important"
                v-if="scope.row.isUse === 'Y'"
                @click="delAdv(scope.row.guid, scope.row)"
                >删除</a
              >
              <a
                class="txt-color"
                style="color: red !important"
                v-if="scope.row.isUse === 'N'"
                @click="delAdv(scope.row.guid, scope.row)"
                >删除</a
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <!-- table end -->
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    let userinfo = JSON.parse(localStorage.userInfo);
    return {
      userinfo: userinfo,
      showMore: false,
      tableHeight: window.innerHeight - 263,
      contentMainHeight: window.innerHeight - 200,
      fullscreenLoading: false,
      tableData: [],
      invoiceDate: [], // 开票日期
      page: {
        pageIndex: 1,
        pageSize: 50,
        advertName: '', //广告名称
        isUse: '', //上架状态
      },
      invoiceTenantList: [],
      receiveTenantList: [],
      type: {
        Y: 'success',
        N: 'info',
      },
      isUseObj: {
        Y: '上架',
        N: '下架',
      },
      reviewStatus: [
        {
          text: '全部',
          value: '',
        },
        {
          text: '上架',
          value: 'Y',
        },
        {
          text: '下架',
          value: 'N',
        },
      ],
    };
  },
  filters: {
    havePic(val) {
      return val ? '有' : '无';
    },
    supported(val) {
      return val === 'Y' ? '支持' : '不支持';
    },
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 310;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 263;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  created() {
    this.getList();
  },
  beforeRouteEnter(to, from, next) {
    if (from.path === '/addAdvConfig') {
      next((vm) => {
        vm.getList();
      });
    } else {
      next();
    }
  },
  methods: {
    //添加广告
    addAdv() {
      this.$router.push({
        path: '/addAdvConfig',
        query: {
          productGuid: localStorage.productGuid,
        },
      });
    },
    getName(name, key) {
      let list = this.getCodeListByKey(key);
      let lisArr = list.filter((item) => item.value == name);
      return lisArr.length ? lisArr[0].text : '-';
    },
    search() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msConfigureService}/advert/data/get`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.invoiceDate = [];
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        advertName: '', //广告名称
        isUse: '', //上架状态
      };
      this.getList();
    },
    addVersion() {
      this.$router.push('/upstreamInvoiceEdit?productGuid=' + this.$route.query.productGuid);
    },
    editForm(guid) {
      this.$router.push('/upstreamInvoiceEdit?guid=' + guid + '&productGuid=' + this.$route.query.productGuid);
    },
    lookForm(guid) {
      this.$router.push({
        path: '/upstreamInvoiceEdit',
        query: {
          guid: guid,
          operationMode: 'look',
          productGuid: this.$route.query.productGuid,
        },
      });
    },
    getList() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msConfigureService}/advert/data/get`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    // 去审核
    toEdit(item) {
      this.$router.push({
        path: '/addAdvConfig',
        query: {
          guid: item.guid,
        },
      });
    },
    // 上/下架操作
    toUse(item, isUse) {
      let messageOjb = {
        Y: '上架后，该广告会展示在移动端，确定操作吗？',
        N: '下架后，该广告将在移动端无法看到，确定操作吗？',
      };
      this.$confirm(messageOjb[isUse], {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let url = `/${serverConfig.msConfigureService}/advert/data/update`;
        item.isUse = isUse;
        this.fullscreenLoading = true;
        this.api.postJson(url, item).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message({
              message: '操作成功',
              type: 'success',
            });
            this.getList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 删除广告配置
    delAdv(guid, item) {
      if (item.isUse === 'Y') {
        this.$message({
          message: '请先下架广告再删除',
          type: 'error',
        });
        return;
      }
      this.$confirm('删除后不可恢复，确定要删除吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let url = `/${serverConfig.msConfigureService}/advert/data/remove`;
        this.api.postJson(url, [guid]).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message({
              message: '删除成功',
              type: 'success',
            });
            this.getList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    getName(name, key) {
      if (!name) return '-';
      let list = this.getCodeListByKey(key);
      if (typeof name == 'object') {
        let newArr = [];
        name.forEach((item) => {
          list.forEach((el) => {
            if (el.value == item) {
              newArr.push(el.text);
            }
          });
        });
        return newArr.length ? newArr.join('、') : '-';
      } else {
        let lisArr = list.filter((item) => item.value == name);
        return lisArr.length ? lisArr[0].text : '-';
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

.el-col-6 {
  margin-bottom: 8px;
  display: flex;
}
.ipt-sty {
  flex: 1;
}
.search-area-div {
  width: 58px;
  text-align: right;
}
</style>
